import { Box3 } from "three";
import type { Mesh, Object3D } from "three";
import type { RoomMeshRole, MeshWithOriginal } from "./types";
import { FLOOR_HEIGHT } from "../../../constants/camera";

export const isMesh = (obj: unknown): obj is Mesh =>
  !!obj && (obj as Mesh).isMesh === true;

export const classifyRoomMeshRole = (mesh: Mesh, roomNode: Object3D): RoomMeshRole => {
  if (mesh === roomNode) return "floor";
  const n = mesh.name.toLowerCase();
  if (n.startsWith("wall_") || n.includes("wall")) return "wall";
  return "other";
};

export const getFloorNumberFromKey = (key: string): number | null => {
  // floor_1, floor_1_collection, floor_f1_collection
  const match = key.match(/floor_(?:f)?(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

export const getStairsFloor = (
  stairsId: string,
  stairsMap: Map<string, MeshWithOriginal[]>
): number => {
  // Parse stairs_1_2_1 -> first digit = lower floor
  const match = stairsId.match(/^stairs_(\d+)/i);
  if (match) {
    return parseInt(match[1], 10);
  }
  // Fallback: if parsing failed, use geometry
  const stairs = stairsMap.get(stairsId);
  if (!stairs || stairs.length === 0) return 1;
  let minY = Infinity;
  for (const { mesh } of stairs) {
    const bbox = new Box3().setFromObject(mesh);
    minY = Math.min(minY, bbox.min.y);
  }
  return Math.floor(minY / FLOOR_HEIGHT) + 1;
};
